// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"559":"a74cde0c","890":"c220646a"}[chunkId] + ".chunk.css";
};